import React$1 from 'react';
import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import PropTypes$1 from 'prop-types';
import Text$1 from '../../basics/Text/Text.js';
import StyledCaption from './Caption.style.js';

const Caption = (_ref) => {
  let {
    caption,
    rotateTo,
    inverse,
    isVisible,
    credits
  } = _ref,
      props = _objectWithoutProperties(_ref, ["caption", "rotateTo", "inverse", "isVisible", "credits"]);

  return /*#__PURE__*/React$1.createElement(StyledCaption, _extends({
    rotateTo: rotateTo,
    isVisible: isVisible,
    inverse: inverse
  }, props), caption && /*#__PURE__*/React$1.createElement(Text$1, {
    content: caption,
    className: "caption__caption"
  }));
};

Caption.propTypes = {
  caption: PropTypes$1.string,
  credits: PropTypes$1.string,
  rotateTo: PropTypes$1.string,
  isVisible: PropTypes$1.bool,
  inverse: PropTypes$1.bool
};
Caption.defaultProps = {
  isVisible: false,
  rotateTo: 'right',
  caption: null,
  credits: null,
  inverse: false
};

export default Caption;
